import { greet } from "./utils.js";

console.log(greet("jxscout"));

function handleClick() {
  console.log("Button clicked");
}

document.getElementById("sourcemaps-lab-btn")?.addEventListener("click", handleClick);
